<template>
  <div id="app" ref='document'>
 
 
 
 

    <router-view  :signedin='signedin' @setsignedin='setsignedin'  @setorder="setorder"  :products='products' :orderdetails='orderdetails' :wlgigs='wlgigs' :loaded='loaded'  :userdatas='userdatas' :datasstatus='datasstatus' :infoset='infoset' :userdataloaded='userdataloaded' :userinfo='userinfo' :infos='infos' :fav='fav'  :favall='favall'  :countrycode='countrycode' :wlgigobj='wlgigobj' :tokens='token' >
      
    </router-view>

  </div>
</template>

<script>
 
const fb = require('./firebase/firebaseconfig.js')

   var wlfav=[]
 import axios from 'axios'

export default {
  name: 'App',
      
 
  data () {

        return{
 

 products:[],
 wlgigs:[],
 token:null,
 loaded:false,
orderdetails:{},
signedin:false,
infos:{},
userinfo:{},
userdatas:{},
datasstatus:false,
infoset:false,
countrycode:'India',
fav:[],
favall:[],
userdataloaded:false,
wlgigobj:{}

}
     
    
  },
 async  created(){

  
 var vm=this
 if(fb.auth.currentUser!=null){


 var docRef = fb.db.collection("mondayhookusers").doc(fb.auth.currentUser.uid);

docRef.get().then((doc) => {
    if (doc.exists) {

      vm.userinfo={
        ...doc.data()
      }
      vm.userdataloaded=true

      }
    })
 }

  },
  mounted(){



     this.initialize() 
//console.log('Firebase cloud messaging object', this.$messaging)
 
} 
   ,
  computed:
  {

 

  },

   
  methods:{

    initialize () {
      var vm=this

      if (!('serviceWorker' in navigator)) {
        console.warn('serviceWorker not working')
        return
      }
      if (!('PushManager' in window)) {
        console.warn('PushManager not working')
        return
      }
      this.hasServiceWorker = true

        

      fb.messaging.usePublicVapidKey('BA2BAT18GSl4PlnRXXOs2r4ZcKSBnNWzu1GGPCoDP7DxNzg2Mf-zg-A61jKr2iih-3iqciZHjT4iM6p5NpsjkFg')
 

 


      navigator.serviceWorker.register('../static/firebase-messaging-sw.js')
        .then((registration) => {


          fb.messaging.useServiceWorker(registration)
          fb.messaging.requestPermission().then(() => {
            fb.messaging.getToken().then((token) => {
                console.log('token')

                console.log(token)
 
                vm.token=token


 
 if(fb.auth.currentUser!=null){

 fb.db.collection('wlshopusers').doc(fb.auth.currentUser.uid).update({

     
      token:vm.token
       
    
      }) 
  }



              //  alert(vm.token )

                //this.$emit('update-token', token)
              
            }).catch((err) => console.log('--- token error:', err))
          }).catch(function (err) {
            console.log('Unable to get permission to notify.', err)
          })
        }).catch(err => {
          console.log('error register', err)
        })




      fb.messaging.onMessage((payload) => {

  
        console.log(payload)

      })







    },

   
   setsignedin(bval){

 this.userinfo={
  ...bval
 }
 this.userdataloaded=true
this.$router.replace({path:'/login'})

   },
 setorder(item){

  this.orderdetails={
    ...item
  }
 }

  }

}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// src/App.vue